import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import { Trad } from "src/components/";

const useStyles = makeStyles(({ palette, spacing }: Theme) => ({
    card: {
        borderRadius: "10px"
    },
    title: {
        padding: "10px 16px 0"
    },
    content: {
        backgroundColor: palette.grey[100],
        padding: spacing(3),
        borderRadius: "10px"
    }
}));

interface ICardProps {
    Title: string;
}

export const _Card: React.FC<ICardProps> = props => {
    const classes = useStyles();

    return (
        <Card className={classes.card}>
            <CardHeader title={Trad.Trad(props.Title)} className={classes.title} titleTypographyProps={{ variant: "subtitle1" }} />
            <CardContent>
                <Box className={classes.content}>{props.children}</Box>
            </CardContent>
        </Card>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/common/Card.tsx